<template>
  <div class="home">
    <hero>
      <transition name="bounce-in">
        <h3 class="tagline">
          Business Development Consultant | Seasoned Front-End Developer
        </h3>
      </transition>

      <h1>Chris Sorrells</h1>
    </hero>

    <div class="contents">
      <p>
        <img src="../assets/me.jpg" alt="Chris Sorrells" />
      </p>
      <p>
        Hello. I'm Chris. I'm doing a bit of work on this site, so in the mean
        time, feel free to reach out to me through
        <a href="https://www.linkedin.com/in/chris-sorrells/" _target="blank">
          LinkedIn
        </a>
        or
        <a href="mailto:clsorrells@gmail.com" _target="blank">email</a>.
      </p>
    </div>
  </div>
</template>

<script>
import Hero from "../components/Hero";

export default {
  components: {
    Hero
  }
};
</script>

<style lang="scss">
.home {
  .tagline {
    text-align: center;
    text-transform: uppercase;
    font-size: 15px;
    letter-spacing: 1.5px;
    color: rgba(255, 255, 255, 0.75);
    margin-bottom: 8px;
  }

  > .contents {
    padding: 60px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 100;

    img {
      border-radius: 50%;
      max-width: 300px;
      margin-bottom: 30px;
    }

    a {
      text-decoration: none;
      color: blue;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
